<template>
  <div style="min-width:280px; max-width:400px;" class="flex-grow-1">
    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="completeLogin">
      <v-card elevation="10">
        <v-overlay absolute :value="isProcessing">
          <v-row justify="center">
            <v-progress-circular indeterminate></v-progress-circular>
          </v-row>
          <v-row justify="center">
            Working on it...
          </v-row>
        </v-overlay>
          <v-toolbar
            style="border-top-left-radius: 4px; border-top-right-radius: 4px;"
            color="info white--text"
            flat
            short>
          <v-icon color="white">mdi-lock</v-icon>
          <v-toolbar-title>Complete Log In</v-toolbar-title>
        </v-toolbar>
        <v-card-text style="min-height:182px">
          <div v-if="isVerifyBySms" class="text-center">
            We're texting your login code to <strong>{{ phoneNumberMasked }}</strong>. Type the code below to finish logging in.
          </div>
          <div v-if="isVerifyByVoice" class="text-center">
            We're calling you at <strong>{{ phoneNumberMasked }}</strong> to tell you your login code. Type the code below to finish logging in.
          </div>
          <v-text-field
            v-model="validationCode"
            class="mt-5"
            label="Code"
            placeholder="1234567"
            :rules="codeRules"
            outlined
            required
            autofocus
          ></v-text-field>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-btn color="primary" :to="{name: 'LoginEmailAddress'}" :disabled="isProcessing" text>
            <v-icon>mdi-restart</v-icon>
            Start Over
          </v-btn>
          <div class="d-flex justify-end" style="width: 100%">
            <v-btn color="primary" :disabled="!valid" @click="completeLogin">
              <v-icon>mdi-check</v-icon>
              Complete Login
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import Logger from '@/services/Logger'
import authutils from '@/mixins/authutils'

export default {
  name: 'LoginVerify',
  mixins: [authutils],
  props: {
    type: {
      type: String,
      default () { return 'sms' }
    },
    emailAddress: {
      type: String,
      default: ''
    },
    phoneNumberMasked: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    valid: false,
    isProcessing: false,
    validationCode: '',
    codeRules: [
      v => !!v || 'Code is required to complete login.',
      v => /[0-9]/.test(v) || 'Enter only numbers.'
    ]
  }),
  computed: {
    isVerifyBySms () {
      return this.type === 'sms'
    },
    isVerifyByVoice () {
      return this.type === 'voice'
    }
  },
  mounted () {
    if (!this.type || !this.emailAddress) {
      this.$router.push({ name: 'LoginEmailAddress' })
    }
  },
  methods: {
    completeLogin () {
      if (!this.$refs.form.validate()) {
        return
      }

      this.isProcessing = true

      this.$store
        .dispatch('auth/completeLogin', {
          emailAddress: this.emailAddress,
          token: this.validationCode
        })
        .then(result => {
          if (result.succeeded === true) {
            this.$emit('logInCompleted')
            this.redirectAfterLogin()
          } else {
            this.startOver(true, result.message)
          }
        })
        .catch(error => {
          Logger.error(error)
          this.startOver(true, error.message)
        })
        .finally(() => {
          this.isProcessing = false
        })
    },
    validate () {
      this.$refs.form.validate()
    },
    startOver (isLoginError = false, errorMessage = null) {
      this.$router.push({
        name: 'LoginEmailAddress',
        params: {
          isLoginError: isLoginError,
          errorMessage: errorMessage,
          emailAddress: this.emailAddress
        }
      })
    }
  }
}
</script>
